import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { Amplitude, LogOnMount, useAmplitude } from "react-amplitude-hooks";

import {
  TitleBox,
  TitleBig,
  HistoryContainer,
  ButtonLineBig
} from "style/components/pc";
import { SubscriptionDetailValue } from "components/Travel/state";
import { toTop } from "components/Travel/function";

import SubscriptionListCard from "components/Travel/PC/Subscription/card";
import SubscriptionDetail from "components/Travel/PC/Subscription/detail";

interface Props {
  match: any;
  history?: any;
}

const SubscriptionList: React.FunctionComponent<Props> = ({
  match,
  history
}) => {
  const [data, setData] = useState([]);
  const [isData, setIsData] = useState(false);
  const [selectedDetail, setSelectedDetail] = useState(false);
  const [selectedData, setSelectedData] = useState(SubscriptionDetailValue);
  const { logEvent } = useAmplitude();
  useEffect(() => {
    toTop();
    if (!isData) {
      if (sessionStorage.getItem("subscription")) {
        const subscriptionData: string =
          sessionStorage.getItem("subscription") || "";
        if (subscriptionData) {
          setIsData(true);
          setData(JSON.parse(subscriptionData));
        }
      } else {
        window.location.replace("/travel/mrt/subscription");
      }
    }
  }, [isData]);

  const openDetail = (data: any) => {
    setSelectedData(data);
    setSelectedDetail(true);
  };
  const closeDetail = () => {
    setSelectedDetail(false);
  };
  const goMainPage = () => {
    history.push("/travel/mrt/introduce");
  };

  return (
    <Amplitude>
      <LogOnMount eventType="history_list" />
      <HistoryContainer>
        <TitleBox>
          <TitleBig>가입내역</TitleBig>
        </TitleBox>
        <HistoryCount>
          Chubb 해외여행보험 총{" "}
          <strong className="length">{data.length}</strong>건
        </HistoryCount>
        {data.map((card: any, index: number) => (
          <div
            onClick={() => {
              logEvent("history_detail_button");
              openDetail(card);
            }}
            key={card.no}
          >
            <SubscriptionListCard
              key={card.no}
              index={index}
              data={card}
              match={match}
            />
          </div>
        ))}
        {selectedDetail && (
          <SubscriptionDetail data={selectedData} onClose={closeDetail} />
        )}
        <ButtonWrap>
          <ButtonLineBig
            type="button"
            className="invert"
            onClick={() => {
              logEvent("history_main_button");
              goMainPage();
            }}
          >
            메인으로
          </ButtonLineBig>
        </ButtonWrap>
      </HistoryContainer>
    </Amplitude>
  );
};

export default SubscriptionList;

const HistoryCount = styled.p`
  margin-top: 10px;
  color: ${props => props.theme.text.colorFont};
  font-size: ${props => props.theme.text.sizeFontS};

  .length {
    color: ${props => props.theme.colors.text};
  }
`;

const ButtonWrap = styled.div`
  margin-top: 50px;
  text-align: center;

  button {
    width: 150px;
  }
`;
